var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"content-index-container left-container",attrs:{"noRoute":true}},[_c('el-main',[_c('que-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }